import Vue from 'vue'
import bhUi from '../../components/bh-ui'
import axios from 'axios'
import common from './common'

// import { join } from 'core-js/fn/array'

let u = navigator.userAgent
let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

// let iosNode
// if (isiOS) {
//     iosNode = document.createElement('div')
//     iosNode.id = 'title'
//     iosNode.style.display = 'none'
// }

const native = {
  isiOS: isiOS,
  backNative() {
    console.log('返回')
  },
  sendMsg(mobile, purpose) {
    try {
      if (window.flutterSendMsg) {
        window.flutterSendMsg.postMessage(mobile + '__' + purpose)
      } else if (isiOS) {
        window.webkit.messageHandlers.sendMsg.postMessage([mobile, purpose])
      } else {
        window.native.sendMsg(mobile, purpose)
      }
    } catch (e) {
      console.log(e)
    }
    window.nativeThen = function(res) {
      if (typeof res == 'string') {
        res = JSON.parse(res)
      }
      if (res.code == 200) {
        //
      }
      window.nativeThen = null
    }
  },
  getAppid() {
    try {
      if (isiOS) {
        window.webkit.messageHandlers.getAppid.postMessage(null)
      } else {
        window.native.getAppid()
      }
    } catch (e) {
      console.log(e)
    }
    // window.nativeThen = function(res) {
    //     if(typeof res == "string") {
    //         res = JSON.parse(res)
    //     }
    //     // bhUi.Toast({text: res.data})
    //     if (res.code == 200) {
    //         axios.defaults.headers.common['appid'] = res.data
    //     }
    //     window.nativeThen = null
    // }
  },
  isRealDeviceId(func = () => {}) {
    try {
      if (isiOS) {
        window.webkit.messageHandlers.isRealDeviceId.postMessage(null)
      } else {
        window.native.isRealDeviceId()
      }
    } catch (e) {
      console.log(e)
    }
    window.nativeThen = function(res) {
      if (typeof res == 'string') {
        res = JSON.parse(res)
      }
      if (res.code == 200) {
        func()
      } else {
        bhUi.Toast({text: '您的设备暂时不支持游戏功能'})
      }
      window.nativeThen = null
    }
  },
  login(mobile, verifyCode) {
    try {
      if (isiOS) {
        window.webkit.messageHandlers.login.postMessage([mobile, verifyCode])
      } else {
        window.native.login(mobile, verifyCode)
      }
    } catch (e) {
      console.log(e)
    }
    window.nativeThen = function(res) {
      if (typeof res == 'string') {
        res = JSON.parse(res)
      }
      if (res.code == 200) {
        //
      }
      window.nativeThen = null
    }
  },

  logout() {
    try {
      if (window.flutterLogout) {
        window.flutterLogout.postMessage('logout');
      }

      window.nativeThen = function(res) {
        if (typeof res == 'string') {
          res = JSON.parse(res)
        }
        if (res.code == 200) {
          //
        }
        window.nativeThen = null
      }
    } catch (e) {
      console.log(e)
    }
  },
  exit() {
    // console.log(native)
    try {
      if (window.flutterBackApp) {
        window.flutterBackApp.postMessage('exit');
      } else if (isiOS) {
        // window.exit()
        window.webkit.messageHandlers.exit.postMessage(null)
      } else {
        window.native.exit()
      }
      // window.native.exit()
    } catch (e) {
      console.log(e)
    }
    window.nativeThen = function(res) {
      if (typeof res == 'string') {
        res = JSON.parse(res)
      }
      if (res.code == 200) {
        //
      }
      window.nativeThen = null
    }
  },
  contactCustomerService() {
    try {
      if (isiOS) {
        // window.contactCustomerService()
        window.webkit.messageHandlers.contactCustomerService.postMessage(null)
      } else {
        window.native.contactCustomerService()
      }
    } catch (e) {
      console.log(e)
    }
    window.nativeThen = function(res) {
      if (typeof res == 'string') {
        res = JSON.parse(res)
      }
      if (res.code == 200) {
        //
      }
      window.nativeThen = null
    }
  },
  saveImg(url) {
    try {
      if (window.flutterSaveImage) {
        window.flutterSaveImage.postMessage(url)
      } else if (isiOS) {
        window.webkit.messageHandlers.saveImg.postMessage(url)
      } else {
        window.native.saveImg(url)
      }
    } catch (e) {
      bhUi.Toast({ text: '暂不支持，请截图保存' })
      console.log(e)
    }
    window.nativeThen = function(res) {
      console.log(res)
      if (typeof res == 'string') {
        res = JSON.parse(res)
      }
      if (res.code == 200) {
        //
      }
      window.nativeThen = null
    }
  },
  weChatScan(url) {
    try {
      if (isiOS) {
        window.webkit.messageHandlers.weChatScan.postMessage(url)
      } else {
        window.native.weChatScan(url)
      }
    } catch (e) {
      bhUi.Toast({ text: '暂不支持，请截图保存后扫码' })
      console.log(e)
    }
    window.nativeThen = function(res) {
      if (typeof res == 'string') {
        res = JSON.parse(res)
      }
      if (res.code == 200) {
        //
      }
      window.nativeThen = null
    }
  },
  changeBarColor(color) {
    try {
      if (window.flutterChangeBarColor) {
        window.flutterChangeBarColor.postMessage(color);
      } else if (isiOS) {
        window.webkit.messageHandlers.changeBarColor.postMessage(color)
      } else if(window.native && window.native.changeBarColor) {
        window.native.changeBarColor(color)
      }
    } catch (e) {
      console.log(e)
    }
    window.nativeThen = function(res) {
      if (typeof res == 'string') {
        res = JSON.parse(res)
      }
      if (res.code == 200) {
        //
      }
      window.nativeThen = null
    }
  },
  readQrImg(url, func) {
    try {
      if (isiOS) {
        window.webkit.messageHandlers.readQrImg.postMessage(url)
      } else {
        window.native.readQrImg(url)
      }
    } catch (e) {
      bhUi.Toast({ text: '暂不支持，请截图保存后扫码' })
      console.log(e)
    }
    window.nativeThen = function(res) {
      if (typeof res == 'string') {
        res = JSON.parse(res)
      }
      if (res.code == 200) {
        //
        func(res.data)
      } else {
        bhUi.Toast({ text: '识别失败' })
      }
      window.nativeThen = null
    }
  },
  sendBase64(url) {
    try {
      if (isiOS) {
        window.webkit.messageHandlers.sendBase64.postMessage(url)
      } else {
        window.native.sendBase64(url)
      }
    } catch (e) {
      bhUi.Toast({ text: '暂不支持，请截图保存' })
      console.log(e)
    }
    window.nativeThen = function(res) {
      if (typeof res == 'string') {
        res = JSON.parse(res)
      }
      if (res.code == 200) {
        //
      }
      window.nativeThen = null
    }
  },
  copyText(str) {
    try {
      if (isiOS) {
        window.webkit.messageHandlers.copyText.postMessage(str)
      } else {
        window.native.copyText(str)
      }
    } catch (e) {
      console.log(e)
    }
    window.nativeThen = function(res) {
      if (typeof res == 'string') {
        res = JSON.parse(res)
      }
      if (res.code == 200) {
        bhUi.Toast({ text: '复制成功' })
      }
      window.nativeThen = null
    }
  },
  saveBase64Img(url) {
    try {
      if (window.flutterSaveBase64Img) {
        window.flutterSaveBase64Img.postMessage(url);
      } else if (isiOS) {
        // iosNode.innerHtml = url
        // window.saveBase64Img(url)
        window.webkit.messageHandlers.saveBase64Img.postMessage(url)
      } else {
        window.native.saveBase64Img(url)
      }
      // window.native.saveBase64Img(url)
    } catch (e) {
      bhUi.Toast({ text: '暂不支持，请截图保存' })
      console.log(e)
    }
    window.nativeThen = function(res) {
      if (typeof res == 'string') {
        res = JSON.parse(res)
      }
      if (res.code == 200) {
        //
        bhUi.Toast({ text: '图片保存成功' })
      }
      window.nativeThen = null
    }
  },
  shareImg(data) {
    try {
      if (isiOS) {
        window.webkit.messageHandlers.shareImg.postMessage([
          data.url,
          data.type,
          data.isBase64
        ])
      } else {
        window.native.shareImg(data.url, data.type, data.isBase64)
      }
    } catch (e) {
      bhUi.Toast({ text: '暂不支持，请截图分享' })
      console.log(e)
    }
    window.nativeThen = function(res) {
      if (typeof res == 'string') {
        res = JSON.parse(res)
      }
      if (res.code == 200) {
        //
      }
      window.nativeThen = null
    }
  },
  sendInvitationLink(data) {
    try {
      if (isiOS) {
        // window.sendInvitationLink(data.title, data.remark, data.url)
        // iosNode.innerHtml = `title=${data.title};remark=${data.remark};url=${data.url};`
        window.webkit.messageHandlers.sendInvitationLink.postMessage([
          data.title,
          data.remark,
          data.url,
          data.type
        ])
      } else {
        window.native.sendInvitationLink(
          data.title,
          data.remark,
          data.url,
          data.type
        )
      }
      // window.native.sendInvitationLink(data.title, data.text, data.url)
    } catch (e) {
      bhUi.Toast({ text: '暂不支持' })
      console.log(e)
    }
    window.nativeThen = function(res) {
      if (typeof res == 'string') {
        res = JSON.parse(res)
      }
      if (res.code == 200) {
        //
      }
      window.nativeThen = null
    }
  },
  sendPayString(payType, str, key, func) {
    try {
      if (window.flutterSendPayString) {
        var param = {
          payType,
          str,
          key,
        }
        param = JSON.stringify(param);
        window.flutterSendPayString.postMessage(param);
      } else if (isiOS) {
        window.webkit.messageHandlers.sendPayString.postMessage([
          payType,
          str,
          key
        ])
      } else {
        if (key) {
          window.native.sendPayString(payType, str, key)
        } else {
          window.native.sendPayString(Number(payType), str)
        }
      }
    } catch (e) {
      console.log(e)
    }
    window.nativeThen = function(res) {
      if (typeof res == 'string') {
        res = JSON.parse(res)
      }
      if (res.code == 200) {
        bhUi.Toast({ text: '充值成功' })
        func()
      }
      window.nativeThen = null
    }
  },
  bindWeCat(func) {
    try {
      if (window.flutterWxAuthorization) {
        // bhUi.Toast({text: '调用微信登录'})
        window.flutterWxAuthorization.postMessage('nativeThen');
      } else if (isiOS) {
        // bhUi.Toast({text: '调用微信登录'})
        window.webkit.messageHandlers.bindWeCat.postMessage(null)
      } else {
        window.native.bindWeCat()
      }
    } catch (e) {
      console.log(e)
    }
    window.nativeThen = function(res) {
      if (typeof res == 'string') {
        res = JSON.parse(res)
      }
      // bhUi.Toast({text: res.data})
      if (res.code == 200) {
        func(res.data)
      }
      window.nativeThen = null
    }
  },
  downFile(url) {
    try {
      if (isiOS) {
        window.webkit.messageHandlers.downFile.postMessage(url)
      } else {
        window.native.downFile(url)
      }
    } catch (e) {
      console.log(e)
    }
    window.nativeThen = function(res) {
      if (typeof res == 'string') {
        res = JSON.parse(res)
      }
      if (res.code == 200) {
        //
      }
      window.nativeThen = null
    }
  },
  openVideo(url) {
    try {
      if (isiOS) {
        window.webkit.messageHandlers.openVideo.postMessage(url)
      } else {
        window.native.openVideo(url)
      }
    } catch (e) {
      console.log(e)
    }
    window.nativeThen = function(res) {
      if (typeof res == 'string') {
        res = JSON.parse(res)
      }
      if (res.code == 200) {
        //
      }
      window.nativeThen = null
    }
  },
  openDzbVideo(func) {
    try {
      if (isiOS) {
        window.webkit.messageHandlers.openDzbVideo.postMessage()
      } else {
        window.native.openDzbVideo()
      }
    } catch (e) {
      console.log(e)
    }
    window.nativeThen = function(res) {
      if (typeof res == 'string') {
        res = JSON.parse(res)
      }
      console.log('openDzbVideoThen')
      console.log(res)
      if (res.code == 200) {
        //
        func()
      }
      window.nativeThen = null
    }
  },
  outSystem() {
    try {
      if (isiOS) {
        window.webkit.messageHandlers.outSystem.postMessage(null)
      } else {
        window.native.outSystem()
      }
    } catch (e) {
      console.log(e)
    }
  },
  setDeviceToken(obj) {
    sessionStorage.setItem('zql-token', obj.data.token)
    // bhUi.Toast({text: `setDeviceToken${str}`})
    try {
      if (window.flutterSetDeviceToken) {
        // bhUi.Toast({text: '调用微信登录'})
        window.flutterSetDeviceToken.postMessage(JSON.stringify(obj));
      } else if (isiOS) {
        window.webkit.messageHandlers.setDeviceToken.postMessage(
          JSON.stringify(obj)
        )
      } else {
        window.native.setDeviceToken(JSON.stringify(obj))
      }
    } catch (e) {
      console.log(e)
    }
    window.nativeThen = function(res) {
      if (typeof res == 'string') {
        res = JSON.parse(res)
      }
      if (res.code == 200) {
        //
      }
      window.nativeThen = null
    }
  },
  getDeviceToken() {
    // bhUi.Toast({text: `getDeviceToken`})
    try {
      if (isiOS) {
        window.webkit.messageHandlers.getDeviceToken.postMessage(null)
      } else {
        window.native.getDeviceToken()
      }
    } catch (e) {
      console.log(e)
    }
    window.nativeThen = function(res) {
      // bhUi.Toast({text: `getDeviceToken`})
      if (typeof res == 'string') {
        res = JSON.parse(res)
      }
      if (res.code == 200) {
        sessionStorage.setItem('zql-token', res.data)
      }
      window.nativeThen = null
    }
  },
  openWxApp(appid, path, userName) {
    try {
      if (isiOS) {
        window.webkit.messageHandlers.openWxApp.postMessage([
          appid,
          path,
          userName
        ])
      } else {
        window.native.openWxApp(appid, path, userName)
      }
    } catch (e) {
      console.log(e)
    }
    window.nativeThen = function(res) {
      if (typeof res == 'string') {
        res = JSON.parse(res)
      }
      if (res.code == 200) {
        //
      }
      window.nativeThen = null
    }
  },
  openGame(code, id, name, token) {
    try {
      if (isiOS) {
        console.log([code, id, name, token])
        window.webkit.messageHandlers.openGame.postMessage([
          code,
          id,
          name,
          token
        ])
      } else {
        window.native.openGame(code, id, name, token)
      }
    } catch (e) {
      console.log(e)
    }
    window.nativeThen = function(res) {
      if (typeof res == 'string') {
        res = JSON.parse(res)
      }
      if (res.code == 200) {
        //
      }
      window.nativeThen = null
    }
  },
  openGameDetail(code, url) {
    try {
      if (isiOS) {
        window.webkit.messageHandlers.openGameDetail.postMessage([
          code,
          url
        ])
      } else {
        window.native.openGameDetail(code, url)
      }
    } catch (e) {
      console.log(e)
    }
    window.nativeThen = function(res) {
      if (typeof res == 'string') {
        res = JSON.parse(res)
      }
      if (res.code == 200) {
        //
      }
      window.nativeThen = null
    }

  },
  GotoWithOpenURL(url) {
    console.log(url)
    try {
      if (isiOS) {
        window.webkit.messageHandlers.GotoWithOpenURL.postMessage(url)
      } else {
        window.native.GotoWithOpenURL(url)
      }
    } catch (e) {
      console.log(e)
    }
    window.nativeThen = function(res) {
      if (typeof res == 'string') {
        res = JSON.parse(res)
      }
      if (res.code == 200) {
        //
      }
      window.nativeThen = null
    }
  },
  changeHost(str) {
    try {
      if (isiOS) {
        window.webkit.messageHandlers.changeHost.postMessage(str)
      } else {
        window.native.changeHost(str)
      }
    } catch (e) {
      console.log(e)
    }
    window.nativeThen = function(res) {
      if (typeof res == 'string') {
        res = JSON.parse(res)
      }
      if (res.code == 200) {
        //
      }
      window.nativeThen = null
    }
  },
  // 原生调用js
  toats(text) {
    alert(text)
  },
  toThisLink(url) {
    location.href = url
  },
  getLoginMsg(data) {
    console.log(data)
  },
  setAppid(str) {
    // console.log(str)
    bhUi.Toast({ text: str })
    axios.defaults.headers.common['appid'] = str
  },
  install() {
    Vue.prototype.$native = native
  }
}

// 原生调用js
window.setAppid = function(str) {
  // bhUi.Toast({text: str})
  axios.defaults.headers.common['appid'] = str
}
window.toats = function(text) {
  bhUi.Toast({ text: text })
}
window.nativeThen = function() {}

window.flutterGoBack = function () {
  console.log('flutterGoBack location.href====');
  console.log(location.href);
  
  // 判断是否返回flutter native
  if (location.href.indexOf('#/?') != -1) {
    native.exit()
  } else {
    common.routerBack()
  }
}
export default native
